export default {
  products: [],
}
